import styled from "styled-components";

export const HeaderConatiner = styled.div`
  display: flex;
  padding: 20px 0 10px 0;
  border-bottom: 2px solid #eee;
`;

export const HeaderIcon = styled.img`
  margin-right: 10px;
  /* border: 1px solid black; */
  width : 25px;
  height : 25px;
`;

export const HeaderText = styled.div`
  /* border: 1px solid black; */
  display : flex;
  align-items : center;
  position: relative;
  top : 2px;
  font-weight:bold;
`;
